var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-4 text-center text-h5 font-weight-bold",domProps:{"innerHTML":_vm._s(_vm.field.etiqueta)}})
}
var staticRenderFns = []

export { render, staticRenderFns }